import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  logined: false,
  userInfo: {}
}

const LoginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.logined = true
      state.userInfo = action.payload.userInfo
    },
    logout: (state) => {
      state.logined = false
      state.userInfo = {}
    }
  }
})

export const { loginSuccess, logout } = LoginSlice.actions
export default LoginSlice.reducer
